import React, {Component, useEffect} from "react"
import {Route, Redirect} from "react-router-dom"

import {ContextRoute, Bundle} from "@irati/utils/history/routing"
import RegionProvider from "@irati/region/components/Provider"

import Loading from "@irati/ui/src/Loading"
import Admin from "@irati-web/admin"
import Perks from "@irati-web/perks"
import FlexiRewards from "@irati-web/flexi-rewards"
import PerksAccount from "@irati-web/account"
import Platform from "@irati-web/platform/src/routes/tenant"
import Public from "@irati-web/platform/src/routes/public"
import Recognition from "@irati-web/recognition"
import Bots from "@irati-web/bots"
import Search from "@irati-web/search"
import Onboarding from "@irati-web/onboarding"
import Medical from "@irati-web/medical"
import MySavings from "@irati-web/my-savings"
import Wallet from "@irati-web/wallet"
import Wellness from "@irati-web/wellness"
import Home from "@irati-web/home"
import MFAPopup from "@irati-web/mfa/components/MFAPopup"
import AuthStream from "@irati/auth/streams/auth"
import UnauthedStream from "@irati/auth/streams/unauthed"
import getTenantFromPath from "@irati/identity/helpers/getTenantFromPath"
import {getDomain} from "@irati/utils/links"

import APPS, {
  ACCOUNT,
  ADMIN,
  BOTS,
  PERKS,
  FLEXIREWARDS,
  PLATFORM,
  PUBLIC,
  RECOGNITION,
  SEARCH,
  ONBOARDING,
  MEDICAL,
  SAVINGS,
  WALLET,
  WELLNESS,
  HOME
} from "../routeConfig"
import Providers from "../Providers"
import AuthProvider from "../AuthProvider"

const TenantSubdomainNotFound = () => {
  useEffect(() => {
    const current = getTenantFromPath()
    window.location = `${getDomain("app")}/welcome/login?invalidTenant=${current}`
  }, [])
  return null
}

export default class InternalRoutes extends Component {
  render() {
    return (
      <Providers>
        <RegionProvider useSubdomain>
          {({load}) => (
            <Loading load={load} Error={TenantSubdomainNotFound}>
              <AuthProvider authed={AuthStream} unauthed={UnauthedStream}>
                <Bundle>
                  <ContextRoute app={PLATFORM} apps={APPS} routes={Platform} />
                  <ContextRoute app={ADMIN} apps={APPS} routes={Admin} />
                  <ContextRoute app={PERKS} apps={APPS} routes={Perks} />
                  <ContextRoute app={FLEXIREWARDS} apps={APPS} routes={FlexiRewards} />
                  <ContextRoute app={ACCOUNT} apps={APPS} routes={PerksAccount} />
                  <ContextRoute app={RECOGNITION} apps={APPS} routes={Recognition} />
                  <ContextRoute app={SEARCH} apps={APPS} routes={Search} />
                  <ContextRoute app={ONBOARDING} apps={APPS} routes={Onboarding} />
                  <ContextRoute app={PUBLIC} apps={APPS} routes={Public} />
                  <ContextRoute app={WALLET} apps={APPS} routes={Wallet} />
                  <ContextRoute app={MEDICAL} apps={APPS} routes={Medical} />
                  <ContextRoute app={SAVINGS} apps={APPS} routes={MySavings} />
                  <ContextRoute app={HOME} apps={APPS} routes={Home} />
                  <ContextRoute app={WELLNESS} apps={APPS} routes={Wellness} />
                  <ContextRoute app={BOTS} apps={APPS} routes={Bots} />
                  <Route exact path="/" component={({location}) => <Redirect to={{...location, pathname: APPS.HOME}} />} />
                  <MFAPopup />
                </Bundle>
              </AuthProvider>
            </Loading>
          )}
        </RegionProvider>
      </Providers>
    )
  }
}
